/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Warning': {
    width: 32,
    height: 29,
    viewBox: '0 0 32 29',
    data: '<path pid="0" d="M3.45 29h25.1c2.566 0 4.167-2.783 2.883-5L18.883 2.317C17.6.1 14.4.1 13.117 2.317L.566 24c-1.284 2.217.316 5 2.883 5zM16 17.333c-.917 0-1.667-.75-1.667-1.666v-3.334c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.666v3.334c0 .916-.75 1.666-1.666 1.666zM17.666 24h-3.333v-3.333h3.333V24z" _fill="#FF9800"/>'
  }
})
